export const createCheckboxCriterion = (keyPath, header, typeOfFilter, name) => ({
  typeOfFilter: typeOfFilter ? typeOfFilter : null,
  type_id: `${keyPath}${name === "undefined" ? null : name}`,
  path: keyPath,
  group: header,
  name: name === "undefined" ? null : name,
});
